import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KbaResponse } from '../../model/kbaresponse';
import { RelatedKnowledgeBaseService } from './relatedknowledgebase.service';
import { RelatedKnowledgebaseResult } from './relatedknowledgebaseresult';
import { CommonConstants } from '../../../../../common/constants/common-constants';
import { KbaService } from '../../services/kba.service';



@Component({
    selector: 'zsd-relatedknowledgebase',
    templateUrl: './relatedknowledgebase.component.html',
    styleUrls: ['./relatedknowledgebase.component.scss']
})
export class RelatedKnowledgeBaseComponent implements OnInit {
    id: number;
    limit: number;
    relatedKbArticles: Array<RelatedKnowledgebaseResult> = [];
    error: string;
    requestId: number;
    fromRequestDetailPage = false;
    constructor(private relatedKnowledgebaseService: RelatedKnowledgeBaseService,
        private route: ActivatedRoute, private router: Router, private kbaService: KbaService) {
        this.limit = 5;
        this.error = 'something went wrong';
        this.router.events.subscribe(
            () => {
                if (this.router.url.includes('/requests')) {
                    this.fromRequestDetailPage = true;
                }
            });
    }


    ngOnInit() {
        this.route.params.subscribe(params => {
            this.id = params['id'];
            this.requestId = params['requestId'];
        });
        if (this.fromRequestDetailPage) {
            this.getRelatedKbaForSolution();
        } else {
            this.getTitles();
        }

    }

    getTitles(): void {
        this.relatedKnowledgebaseService.getArticleTitles(this.id, this.limit).subscribe(
            (articleResponse: KbaResponse) => {
                for (let kbaResponseResult of articleResponse.results) {
                    let relateds = new RelatedKnowledgebaseResult();
                    relateds.relatedknowledgebaseId = kbaResponseResult.kbaId;
                    relateds.relatedknowledgebaseTitle = kbaResponseResult.title;
                    this.relatedKbArticles.push(relateds);
                }
            },
            error => this.error = error);
    }

    getRelatedKbaForSolution(): void {
        this.relatedKnowledgebaseService.getrelatedSoltionArticleTitles(this.requestId, this.limit).subscribe(
            (articleResponse: KbaResponse) => {
                for (let kbaResponseResult of articleResponse.results) {
                    let relateds = new RelatedKnowledgebaseResult();
                    relateds.relatedknowledgebaseId = kbaResponseResult.kbaId;
                    relateds.relatedknowledgebaseTitle = kbaResponseResult.title;
                    this.relatedKbArticles.push(relateds);
                }
            },
            error => this.error = error);
    }

    onClickTitle(kbaId: number): void {
        this.kbaService.increaseViewCount(kbaId).subscribe();
        this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
            this.router.navigate([CommonConstants.SELFHELP_KBA_COMPONENT + '/' + kbaId]));

    }
}

